import React from 'react';
import { Box, Paper, Typography, FormControlLabel, Switch, RadioGroup, Radio } from '@mui/material';

const SIDEBAR_KEY = 'ui:sidebar:visible';
const THEME_KEY = 'ui:theme:mode';

const ViewSettingsTab: React.FC = () => {
  const [sidebar, setSidebar] = React.useState<boolean>(() => {
    const raw = localStorage.getItem(SIDEBAR_KEY);
    return raw == null ? true : raw === '1';
  });
  const [mode, setMode] = React.useState<'light'|'dark'>(() => {
    const raw = localStorage.getItem(THEME_KEY) as 'light'|'dark' | null;
    return raw || 'light';
  });

  React.useEffect(() => {
    try { localStorage.setItem(SIDEBAR_KEY, sidebar ? '1' : '0'); } catch {}
    // Wyślij zdarzenie do aplikacji – Layout/Sidebar mogą nasłuchiwać
    window.dispatchEvent(new CustomEvent('ui:sidebar:toggle', { detail: { visible: sidebar } }));
  }, [sidebar]);

  React.useEffect(() => {
    try { localStorage.setItem(THEME_KEY, mode); } catch {}
    window.dispatchEvent(new CustomEvent('ui:theme:toggle', { detail: { mode } }));
  }, [mode]);

  return (
    <Box sx={{ px: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 2 }}>Widok</Typography>
      <Paper sx={{ p: 2, mb: 2 }}>
        <FormControlLabel control={<Switch checked={sidebar} onChange={(e) => setSidebar(e.target.checked)} />} label="Pokaż lewy pasek (sidebar)" />
      </Paper>
      <Paper sx={{ p: 2 }}>
        <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1 }}>Wygląd</Typography>
        <RadioGroup row value={mode} onChange={(e) => setMode(e.target.value as any)}>
          <FormControlLabel value="light" control={<Radio />} label="Jasny" />
          <FormControlLabel value="dark" control={<Radio />} label="Ciemny" />
        </RadioGroup>
      </Paper>
    </Box>
  );
};

export default ViewSettingsTab;


